import { Modal } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { ProcuratDepartmentPersonsTableData } from 'components/Procurat/tables/ProcuratDepartmentPersonsTable';
import { GrantRoleValues, ImportPersonsForm } from '../forms/ImportPersonsForm';

type ImportPersonsModalProps = {
  open: boolean;
  personsData: ProcuratDepartmentPersonsTableData[];
  onImport: (x: GrantRoleValues) => void;
  onClose: () => void;
};

export const ImportPersonsModal = ({ open, personsData, onImport, onClose }: ImportPersonsModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal key={'import.persons'} isOpen={open} onRequestClose={onClose} title={t('procuratImport.importPersons')}>
      <ImportPersonsForm personsData={personsData} onImport={onImport} onClose={onClose} />
    </Modal>
  );
};
